import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/oms-charge-service/v1";

//查询充电订单错误代码集合
export const getOrderFaultCodeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/charge/order/fault_code/list", data, config);
};
//批量更新充电订单错误
export const updataOrderFaultCode = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/charge/order/fault_code/update", data, config);
};
